import { useEffect } from 'react'

import styles from './styles/InstitutionsPanel.css'
import TalkToUs from './TalkToUs'
import PartnerValueProp from './PartnerValueProp'
import PartnersPanel from './PartnersPanel'
import AwardsAndPress from './Awards'
import P from 'components/typography/Paragraph'
import * as analytics from 'lib/analytics'
import Endorsements from '../home/Endorsements'
import Button from '../forms/Button'
import classNames from 'classnames'
import Link from '../misc/Link'
import Card from '../layout/Card'

const InstitutionsPanel = () => {
  useEffect(() => {
    analytics.event({
      category: 'Partners',
      action: 'View Institutions Partners Page'
    })
  }, [])

  return (
    <div className={styles.layout}>
      <TalkToUs
        header={false}
        cta={
          <Button className={classNames(styles.submitBtn, styles.transparentBtn)} onClick={() => window.open(`${CONFIG.assetsBaseURL}/documents/scite-case-study-university-library.pdf`)} color='transparent'>View case study</Button>
        }
        pricingTab='organizations'
        subheader='Get in touch with our team to learn more about how scite can help you better discover and understand research. View our case study to see how we helped a university library provide their students, faculty, and staff a better way to discover, contextualize, and understand research.'
      />
      <PartnerValueProp
        className={styles.valueProp}
        id='super-powers'
        illo={`${CONFIG.assetsBaseURL}/images/icons/institution-spyglass.svg`}
        header='Help students and researchers discover how literature is being talked about'
        cta='Start a trial for your organization'
        ctaLocation='/pricing?tab=organizations'
        link='See what we offer researchers'
        linkLocation='/partners/researchers'
      >
        <P>
          Seeing <i>how</i> an article has been cited is vastly more useful than simply seeing how many times an article has been cited. With scite, researchers can more effectively discover and evaluate research articles by directly seeing what subsequent publications say about their findings through citation statements -- the in-text references from papers where citations happen.
        </P>
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='search-citations'
        header="Provide students and faculty with direct access to the world's knowledge"
        cta='Search Citation Statements'
        ctaLocation='/search/citations'
        link='See how we help students'
        linkLocation='/partners/students'
      >
        <P>
          Empower your students and faculty with an unparalleled way to discover and understand research.
          Search over {CONFIG.defaultCitationsTotalText} citation statements for how methods, arugments, results, claims, datasets, and more are being used.
        </P>
        <img alt='citation-statement-search' src={`${CONFIG.assetsBaseURL}/images/citation-statement-search.png`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='author-marketing'
        header='Support authors'
        cta='Find out more'
        ctaLocation='/author-marketing'
      >
        <P>
          Support authors at your institution by letting them know how they have been cited and indicating if their work has been supported or contrasted in the literature.
        </P>
        <Card level={1}>
          <img alt='example email' className={styles.emailImage} src={`${CONFIG.assetsBaseURL}/images/illustrations/email-alert.png`} />
        </Card>
        <br />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='understand-institution'
        header='Better understand how publications from your institution are being cited'
        cta='Find your institution'
        ctaLocation='/affiliations'
      >
        <P>
          Use scite dashboards to better understand how articles from your institution have been cited. Discover how many supporting or contrasting citations your institution has received and what is the most supported or contrasted article from your institution.
        </P>
        <img alt='academic-dashboard' src={`${CONFIG.assetsBaseURL}/images/illustrations/academic-dashboard.png?v=1`} />
      </PartnerValueProp>
      <PartnersPanel
        header='Who we’re working with'
        subheader={
          <>
            We've partnered with leading universities like <Link underline blue href='https://libguides.lib.hku.hk/scite'>The University of Hong Kong</Link> and <Link underline blue href='https://www.cshl.edu/library-news/webinar-about-our-new-subscription-to-scite/'>Cold Spring Harbor Labratories</Link> to help researchers discover and evaluate literature more effectively.
          </>
        }
      />
      <AwardsAndPress />
      <Endorsements />
      <TalkToUs
        pricingTab='organizations'
      />
    </div>
  )
}

export default InstitutionsPanel
